import { Component, HostListener, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { commonErrorMessage, technologyErrorPageMessage } from 'src/app/constants/error-message-constant';
import { ChildTechnologyPreferenctConstant } from 'src/app/constants/label-constants';
import { CommonService } from 'src/app/services/common/common.service';
import { DirtycheckDialogboxComponent } from '../../dirtycheck-dialogbox/dirtycheck-dialogbox.component';
import { MatSelect } from '@angular/material/select';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-add-child-technology-preference',
  templateUrl: './add-child-technology-preference.component.html',
  styleUrls: ['./add-child-technology-preference.component.scss']
})
export class AddChildTechnologyPreferenceComponent {
  ChildTechnologyForm: FormGroup = this.formBuilder.group({});
  @Input() ChildTechnologyPreferenceId: any;
  CommonConstant: any = [];
  ChildTechnologyConstant: any = [];
  ChildTechnologyPhoto: any;
  ChildTechnologyLogo: string = '';
  flag: boolean = true;
  errorMessage: any = [];
  commonErrorMessage: any = [];
  modalButton: boolean = false;
  technologyPreferenceList: any[] = [];
  TechnologyPreferenceId: any = '';
  protected _onDestroy = new Subject();
  @ViewChild('singleSelect', { static: true })
  singleSelect!: MatSelect;
  public technologyFilterCtrl: FormControl = new FormControl();
  public technologyFilteredData: ReplaySubject<any> = new ReplaySubject();
  @HostListener('window:beforeunload', ['$event'])
  public canDeactivate(event: BeforeUnloadEvent): void {
    if (this.ChildTechnologyForm.dirty) {
      event.preventDefault();
      event.returnValue = false;
    }
  }
  protected filterTechnologyPreference() {
    if (!this.technologyPreferenceList) {
      return;
    }
    let search = this.technologyFilterCtrl.value;
    if (!search) {
      this.technologyFilteredData.next(this.technologyPreferenceList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    this.technologyFilteredData.next(
      this.technologyPreferenceList.filter(
        (data) => data.value.toLowerCase().indexOf(search) > -1
      )
    );
  }

  ngOnDestroy() {
    this._onDestroy.next(1);
    this._onDestroy.complete();
  }

  constructor(
    private formBuilder: FormBuilder,
    private CommonService: CommonService,
    private toastr: ToastrService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    public modalService: NgbActiveModal,
    public ModalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.getParentTechnologyPreferenceList();
    this.technologyFilteredData.next(this.technologyPreferenceList.slice());
    this.technologyFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterTechnologyPreference();
      });
    this.CommonConstant = CommonConstant;
    this.ChildTechnologyConstant = ChildTechnologyPreferenctConstant;
    this.errorMessage = technologyErrorPageMessage;
    this.commonErrorMessage = commonErrorMessage;
    this.onInitChildTechnolgyForm();
    if (this.ChildTechnologyPreferenceId > 0) {
      this.getChildTechnologyDetail(this.ChildTechnologyPreferenceId);
    }
    else {
      this.ChildTechnologyPreferenceId = 0;
    }
  }

  onInitChildTechnolgyForm() {
    this.ChildTechnologyForm = this.formBuilder.group({
      ChildTechnologyPreferenceId: [0],
      ChildTechnologyName: ['', [Validators.required, Validators.maxLength(100)]],
      ChildTechnologyLogo: [''],
      TechnologyPreferenceId: ['', [Validators.required]],
    });
  }

  get ChildTechnologyFormControl() {
    return this.ChildTechnologyForm.controls;
  }

  onCancel() {
    if (this.ChildTechnologyForm.dirty) {
      const modalRef = this.ModalService.open(DirtycheckDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.ChildTechnologyForm = this.ChildTechnologyForm;
    }
    else {
      this.modalService.close();
    }
  }

  getChildTechnologyDetail(ChildTechnologyId: number) {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.ChildTechnologyPreferences.TechnlogyPreferenceById.replace("{id}", ChildTechnologyId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {       
        this.spinner.hide();
        if (data.data.logo) {
          (<HTMLInputElement>document.getElementById('ChildTechnologyPreview')).setAttribute("src", data.data.logo);
        }
        else {
          (<HTMLInputElement>document.getElementById('ChildTechnologyPreview')).setAttribute("src", "assets/img/logo_placeholder.svg");
        }
        this.setChildTechnologyForm(data.data);
      },
      error: (err) => {
        console.log('getChildTechnologyDetail-Error', err);
      }
    });
  }

  setChildTechnologyForm(data) {
    this.ChildTechnologyForm.setValue({
      ChildTechnologyPreferenceId: (data.technologyPreferenceId) ? data.technologyPreferenceId : 0,
      ChildTechnologyName: data.name,
      ChildTechnologyLogo: data.logo ? data.logo : '',
      TechnologyPreferenceId: data.parentTechnologyPreferenceId,
    });
    this.ChildTechnologyLogo = data.logo;
  }

  saveChildTechnology() {
    this.modalButton = true;
    if (!this.ChildTechnologyForm.valid) {
      return;
    }
    this.spinner.show();
    const form = new FormData();
    this.spinner.show();
    form.append('parentTechnologyPreferenceId', this.ChildTechnologyForm.value.TechnologyPreferenceId.toString())
    form.append('technologyPreferenceId', this.ChildTechnologyForm.value.ChildTechnologyPreferenceId ? this.ChildTechnologyForm.value.ChildTechnologyPreferenceId.toString() : '0');
    form.append('name', this.ChildTechnologyForm.value.ChildTechnologyName.trim());
    form.append("logoFile", this.ChildTechnologyPhoto);
    form.append("logo", this.ChildTechnologyLogo);
    const apiUrl = this.apiUrl.apiUrl.ParentTechnologyPreferences.SaveTechnologyPreference;
    this.CommonService.doPost(apiUrl, form).pipe().subscribe({
      next: (data) => {
        if (data.success) {
          this.modalButton = false;
          this.spinner.hide();
          this.modalService.close('save');
          if(this.ChildTechnologyPreferenceId > 0){
            this.toastr.success("Child technology preference updated successfully");
          }
          else{
            this.toastr.success(data.message);
          }
        }
        else {
          this.spinner.hide();
          this.toastr.error(data.message);
          this.modalButton = false;
        }
      },
      error: (er) => {
        console.error(er)
      }
    });
  }

  getParentTechnologyPreferenceList() {
    const apiUrl = this.apiUrl.apiUrl.ParentTechnologyPreferences.GetParentTechnologyPreferenceList;
    this.CommonService.doGet(apiUrl)
      .pipe()
      .subscribe({
        next: (data) => {
          if (data && data.data && data.data.length > 0) {
            for (let i = 0; i < data.data.length; i++) {
              this.technologyPreferenceList.push({
                id: data.data[i].technologyPreferenceId,
                value: data.data[i].name,
              });
            }
            this.filterTechnologyPreference();
          }
        },
        error: (err) => {
          console.log('getHandlerList-Error', err);
        }
      });
  }

  onFileChanged(event: any) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      let file: any;
      var ext = event.target.files[0].name.match(/\.([^\.]+)$/)[1];
      switch (ext.toLowerCase()) {
        case 'jpg':
        case 'jpeg':
        case 'png':
          break;
        default:
          this.toastr.error("Please select only JPG,JPEG or PNG Image");
          (<HTMLInputElement>document.getElementById('uploadChildTechnologyImage')).value = "";
          return true;
      }
      reader.onload = function (e) {
        file = e.target;
        (<HTMLInputElement>document.getElementById('ChildTechnologyPreview')).setAttribute("src", file.result);
      }
      reader.readAsDataURL(event.target.files[0]);
      this.ChildTechnologyPhoto = event.target.files[0];
    } else {
      (<HTMLInputElement>document.getElementById('ChildTechnologyPreview')).setAttribute("src", "assets/img/logo_placeholder.svg");
      this.ChildTechnologyPhoto = null;
      (<HTMLInputElement>document.getElementById('uploadChildTechnologyImage')).value = '';
      this.ChildTechnologyPhoto.controls['ChildTechnology'].setValue('');
    }
  }
}